import styled from "styled-components";

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export { Column };
